<template>
  <form
    class="site-search"
    :class="`site-search--${variant}`"
    role="search"
    @submit.prevent="submitSearch"
  >
    <div class="site-search__field">
      <span class="site-search__icon" aria-hidden="true"></span>
      <input
        v-model="searchQuery"
        class="site-search__input"
        type="search"
        :placeholder="placeholder"
        aria-label="Search"
        autocomplete="off"
      />
    </div>

    <button class="site-search__button" type="submit">
      Search
    </button>
  </form>
</template>

<script>
export default {
  name: "SiteSearch",
  props: {
    placeholder: {
      type: String,
      default: "Search news",
    },
    variant: {
      type: String,
      default: "light",
      validator(value) {
        return ["light", "dark"].includes(value);
      },
    },
  },
  data() {
    return {
      searchQuery: typeof this.$route.query.q === "string" ? this.$route.query.q : "",
    };
  },
  watch: {
    "$route.query.q"(value) {
      this.searchQuery = typeof value === "string" ? value : "";
    },
  },
  methods: {
    submitSearch() {
      const query = this.searchQuery.trim();

      this.$router.push({
        name: "berita",
        query: query ? { q: query } : {},
      });
    },
  },
};
</script>

<style scoped>
.site-search {
  --field-bg: #ffffff;
  --field-border: rgba(8, 78, 139, 0.14);
  --field-text: #063761;
  --field-placeholder: rgba(6, 55, 97, 0.56);
  --field-shadow: 0 16px 28px rgba(7, 44, 76, 0.1);
  --icon-color: #084e8b;
  --button-bg: linear-gradient(135deg, #0c6abc, #084e8b);
  --button-text: #ffffff;
  --button-shadow: 0 16px 26px rgba(8, 78, 139, 0.22);

  display: flex;
  align-items: center;
  gap: 10px;
  width: min(100%, 360px);
}

.site-search--dark {
  --field-bg: rgba(255, 255, 255, 0.14);
  --field-border: rgba(255, 255, 255, 0.18);
  --field-text: #ffffff;
  --field-placeholder: rgba(255, 255, 255, 0.74);
  --field-shadow: 0 16px 28px rgba(0, 0, 0, 0.16);
  --icon-color: #ffffff;
  --button-bg: linear-gradient(135deg, #ffffff, #edf4f9);
  --button-text: #084e8b;
  --button-shadow: 0 16px 26px rgba(0, 0, 0, 0.18);
}

.site-search__field {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
}

.site-search__icon {
  position: absolute;
  top: 50%;
  left: 13px;
  width: 15px;
  height: 15px;
  background-color: var(--icon-color);
  transform: translateY(-50%);
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='11' cy='11' r='7'/%3E%3Cpath d='m21 21-4.35-4.35'/%3E%3C/svg%3E")
    center / contain no-repeat;
  mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='11' cy='11' r='7'/%3E%3Cpath d='m21 21-4.35-4.35'/%3E%3C/svg%3E")
    center / contain no-repeat;
}

.site-search__input {
  width: 100%;
  border: 1px solid var(--field-border);
  border-radius: 18px;
  padding: 12px 16px 12px 38px;
  background: var(--field-bg);
  box-shadow: var(--field-shadow);
  backdrop-filter: blur(14px);
  color: var(--field-text);
  font-size: 0.95rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.site-search__input::placeholder {
  color: var(--field-placeholder);
}

.site-search__input:focus {
  border-color: rgba(12, 106, 188, 0.42);
  box-shadow: 0 0 0 4px rgba(12, 106, 188, 0.12);
  outline: none;
}

.site-search__button {
  flex: 0 0 auto;
  border: 0;
  border-radius: 18px;
  padding: 12px 18px;
  background: var(--button-bg);
  box-shadow: var(--button-shadow);
  color: var(--button-text);
  font-size: 0.92rem;
  font-weight: 700;
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

.site-search__button:hover {
  transform: translateY(-1px);
}

.site-search__button:focus-visible {
  outline: 2px solid #f15a24;
  outline-offset: 3px;
}

@media (max-width: 768px) {
  .site-search {
    width: 100%;
  }

  .site-search__input {
    padding-top: 11px;
    padding-bottom: 11px;
  }

  .site-search__button {
    padding: 11px 16px;
  }
}
</style>
